var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-f3", staticStyle: { "min-height": "900px" } },
    [
      _c("div", { staticClass: "f22 fb wrap pad20-t pad15-b" }, [
        _vm._v("订单详情")
      ]),
      _vm.loaded
        ? _c(
            "div",
            { staticClass: "gray3 wrap" },
            [
              _c(
                "div",
                { staticClass: "flex bg-white mar20-b state" },
                [
                  _c("div", { staticClass: "text-center left" }, [
                    _c("div", { staticClass: "pad25-t pad5-b" }, [
                      _vm._v("订单编号：" + _vm._s(_vm.detail.orderId))
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "flex items-center pad10-b justify-center",
                        attrs: {
                          target: "_blank",
                          href:
                            "https://work.weixin.qq.com/kfid/kfcd200d8c554673e56"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              "https://nfs.nxin.com/cms_image_02128766-9b82-470c-b555-b177a4bc8473.png"
                          }
                        }),
                        _c("div", { staticClass: "pad5-l" }, [
                          _vm._v("联系客服")
                        ]),
                        _vm.detail.orderDtlBo.orderType == 3
                          ? _c("span", { staticClass: "behalfPurchaseOrder" }, [
                              _vm._v("代采订单")
                            ])
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center items-center pad40-b"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fb f26",
                            staticStyle: { color: "#71b247" }
                          },
                          [_vm._v(_vm._s(_vm.detail.orderStCn))]
                        ),
                        _vm.detail.orderDtlBo.orderType == 3 ||
                        _vm.detail.orderDtlBo.orderType == 4
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "behalfPurchaseOrder pad10-lr mar10-lr radius4"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.detail.orderDtlBo.orderType == 3
                                        ? "代采订单"
                                        : "预订单"
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pad40-b flex flex-wrap text-center flex-item1 pad20-lr btn-group"
                      },
                      [
                        _vm._l(_vm.buttonList, function(button) {
                          return [
                            button.explain === ""
                              ? _c(
                                  "div",
                                  {
                                    key: button.buttonCode,
                                    staticClass: "item mar12-r mar10-b",
                                    on: {
                                      click: function($event) {
                                        return _vm.buttonSubmit(
                                          button,
                                          _vm.detail
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(button.buttonName) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _c(
                                  "el-tooltip",
                                  {
                                    key: "a" + button.buttonCode,
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: button.explain,
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item mar12-r mar10-b",
                                        on: {
                                          click: function($event) {
                                            return _vm.buttonSubmit(
                                              button,
                                              _vm.detail
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(button.buttonName))]
                                    )
                                  ]
                                )
                          ]
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "item mar12-r mar10-b",
                            on: {
                              click: function($event) {
                                _vm.editOrderSnapshotDialogVisible = true
                              }
                            }
                          },
                          [_vm._v("订单快照")]
                        )
                      ],
                      2
                    )
                  ]),
                  _c("order_info_dtl", { attrs: { detail: _vm.detail } })
                ],
                1
              ),
              _vm.detail.orderDtlBo.orderType == 4
                ? _c("div", { staticClass: "bg-white f14 pad20" }, [
                    _vm.showPreOrderInboundInfo
                      ? _c(
                          "div",
                          {
                            staticClass: "pad20 flex flex-item1 mar20-b border"
                          },
                          [
                            _c("div", { staticClass: "item" }, [
                              _c("div", { staticClass: "fb f15 mar15-b" }, [
                                _vm._v("入库通知信息")
                              ]),
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "w92 mar10-b gray6" },
                                  [_vm._v("时间：")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex-auto mar10-b" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.noticeOperationRecord
                                          ? _vm.noticeOperationRecord
                                              .operatorContent
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "w92 mar10-b gray6" },
                                  [_vm._v("操作人：")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex-auto mar10-b" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.noticeOperationRecord
                                          ? _vm.noticeOperationRecord.boIdName
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "item border-l pad20-l" },
                              [
                                _c("div", { staticClass: "fb f15 mar15-b" }, [
                                  _vm._v("入库验收信息")
                                ]),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w92 mar10-b gray6" },
                                    [_vm._v("时间：")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.acceptanceOperationRecord
                                            ? _vm.acceptanceOperationRecord
                                                .operatorContent
                                            : "-"
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w92 mar10-b gray6" },
                                    [_vm._v("操作人：")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.acceptanceOperationRecord
                                            ? _vm.acceptanceOperationRecord
                                                .boIdName
                                            : "-"
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "item border-l pad20-l" },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w130 mar10-b gray6" },
                                    [_vm._v("入库通知验收单：")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto mar10-b" },
                                    [
                                      _vm.detail.yddNoticeOrderContractSignNum
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "blue pointer",
                                              on: {
                                                click: function($event) {
                                                  return _vm.contractPreviewHandle(
                                                    _vm.detail
                                                      .yddNoticeOrderContractSignNum
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                查看\n              "
                                              )
                                            ]
                                          )
                                        : _c("div", [_vm._v("-")])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "pad20 mar20-b border" }, [
                      _c("div", { staticClass: "fb f16 mar15-b" }, [
                        _vm._v("付款信息")
                      ]),
                      _c("div", { staticClass: "flex flex-item1" }, [
                        _c("div", { staticClass: "item" }, [
                          _vm._v("\n            支付类型："),
                          _c("span", { staticClass: "gray9" }, [
                            _vm._v(_vm._s(_vm.detail.paymentTypeCn))
                          ])
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _vm._v("\n            支付状态："),
                          _c("span", { staticClass: "gray9" }, [
                            _vm._v(_vm._s(_vm.detail.paymentStCn))
                          ])
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _vm._v("\n            定金金额："),
                          _c("span", { staticClass: "gray9" }, [
                            _vm._v("￥" + _vm._s(_vm.detail.pmoney))
                          ])
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pad20 flex flex-item1 mar20-b flex-item1 border certificate"
                      },
                      [
                        _c("div", { staticClass: "flex flex-column item" }, [
                          _vm._m(0),
                          _c("div", { staticClass: "pad10-b" }, [
                            _vm._v(
                              "选择图片后需点击【确认上传】按钮完成凭证上传"
                            )
                          ]),
                          _c("div", { staticClass: "flex flex-wrap upload" }, [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-center relative pointer box"
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadVoucher",
                                      attrs: {
                                        multiple: "",
                                        limit: 30,
                                        action:
                                          _vm.env.VUE_APP_fileserver +
                                          "persistentUpload",
                                        "list-type": "picture-card",
                                        "file-list": _vm.buyerVoucherPicList,
                                        "on-success": _vm.uploadVoucherSuccess,
                                        "on-remove": _vm.uploadVoucherRemove,
                                        "before-upload": _vm.uploadBefore,
                                        "on-exceed": _vm.uploadVoucherExceed
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("./images/add.png")
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("div", { staticClass: "text-right pad15-r" }, [
                                _vm._v("上传文件")
                              ])
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "mar10-l",
                                on: { click: _vm.imgTransfer }
                              },
                              [
                                _vm._m(1),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center",
                                    class: {
                                      "pad10-t":
                                        _vm.buyerVoucherPicList &&
                                        _vm.buyerVoucherPicList.length
                                    }
                                  },
                                  [_vm._v("手机传图")]
                                )
                              ]
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pointer white text-center mar20-t upload-btn",
                              on: { click: _vm.submitBuyerVoucher }
                            },
                            [_vm._v("确认上传")]
                          ),
                          _c("div", { staticClass: "flex-auto" })
                        ]),
                        _c("div", { staticClass: "border-l pad20-l item" }, [
                          _c("div", { staticClass: "f16 fb mar15-b" }, [
                            _vm._v("订单凭证")
                          ]),
                          _vm.detail.voucherPicMapList &&
                          _vm.detail.voucherPicMapList.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "relative certificate",
                                  staticStyle: {
                                    height: "270px",
                                    "overflow-y": "auto"
                                  }
                                },
                                _vm._l(_vm.detail.voucherPicMapList, function(
                                  voucherMap,
                                  voucherMapIdnex
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: voucherMapIdnex,
                                      staticClass: "relative"
                                    },
                                    [
                                      voucherMapIdnex !=
                                      _vm.detail.voucherPicMapList.length - 1
                                        ? _c("div", {
                                            staticClass: "line",
                                            staticStyle: { bottom: "-28px" }
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "flex items-center" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center mar5-r"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "radius20 z-index2 ball"
                                              }),
                                              _c(
                                                "div",
                                                { staticClass: "mar10-l" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      voucherMap.voucherType ==
                                                        "SELLER"
                                                        ? "卖家"
                                                        : "买家"
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        voucherMap.boIdName
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        voucherMap.boIdPhone
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c("div", { staticClass: "gray9" }, [
                                            _vm._v(
                                              _vm._s(voucherMap.creationDate)
                                            )
                                          ]),
                                          voucherMap.voucherType == "BUYER" &&
                                          (_vm.detail.orderStatus == "1" ||
                                            _vm.detail.orderStatus == "2" ||
                                            _vm.detail.orderStatus == "3")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "mar10-l red",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.delBuyerVoucherMap(
                                                        voucherMap
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  删除\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex mar10-t mar20-b mar19-l flex-wrap"
                                        },
                                        _vm._l(
                                          voucherMap.voucherPicList,
                                          function(vouche, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "wh64 mar5-b radius4 mar5-r relative overflow"
                                              },
                                              [
                                                voucherMap.voucherType ==
                                                  "BUYER" &&
                                                (_vm.detail.orderStatus ==
                                                  "1" ||
                                                  _vm.detail.orderStatus ==
                                                    "2" ||
                                                  _vm.detail.orderStatus == "3")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex radius100 del-voucher absolute justify-center items-center pointer del",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.delBuyerVoucher(
                                                              vouche.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("./images/del.png")
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.isZip(vouche.url)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "line-height": "64px",
                                                          display: "block",
                                                          "text-align": "center"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: vouche.url
                                                            }
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              attrs: {
                                                                src:
                                                                  "https://files.nxin.com/mobile/public/zip.png"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  : _vm.isWord(vouche.url)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "line-height": "64px",
                                                          display: "block",
                                                          "text-align": "center"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: vouche.url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              attrs: {
                                                                src:
                                                                  "https://files.nxin.com/mobile/public/word.png"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  : _vm.isPdf(vouche.url)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "line-height": "64px",
                                                          display: "block",
                                                          "text-align": "center"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: vouche.url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              attrs: {
                                                                src:
                                                                  "https://files.nxin.com/mobile/public/pdf.png"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  : _vm.isExcel(vouche.url)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "line-height": "64px",
                                                          display: "block",
                                                          "text-align": "center"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: vouche.url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              attrs: {
                                                                src:
                                                                  "https://files.nxin.com/mobile/public/excel.png"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  : _c("el-image", {
                                                      attrs: {
                                                        src:
                                                          vouche.url +
                                                          "?imageView2/1/w/80/h/80",
                                                        "preview-src-list": voucherMap.voucherPicList.map(
                                                          function(item) {
                                                            return item.url
                                                          }
                                                        ),
                                                        "initial-index": index
                                                      }
                                                    })
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm.detail.takeGoodsNum != ""
                            ? _c(
                                "div",
                                { staticClass: "flex mar40-t items-center" },
                                [
                                  _c("div", [_vm._v("提货单号：")]),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.detail.takeGoodsNum))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm.detail.pickupInfo
                      ? _c(
                          "div",
                          { staticClass: "pad20 border" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center mar15-b" },
                              [
                                _c("div", { staticClass: "fb f16" }, [
                                  _vm._v("提货明细")
                                ]),
                                _c("div", { staticClass: "flex-auto" }),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pad15-lr flex radius4 pick-up-details-collect"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "预定数量：" +
                                            _vm._s(
                                              _vm.detail.pickupInfo.ydQuantity
                                            )
                                        )
                                      ]),
                                      _c("div", { staticClass: "mar20-l" }, [
                                        _vm._v(
                                          "已提数量：" +
                                            _vm._s(
                                              _vm.detail.pickupInfo.ytQuantity
                                            )
                                        )
                                      ]),
                                      _c("div", { staticClass: "mar20-l" }, [
                                        _vm._v(
                                          "执行中：" +
                                            _vm._s(
                                              _vm.detail.pickupInfo.zxzQuantity
                                            )
                                        )
                                      ]),
                                      _c("div", { staticClass: "mar20-l" }, [
                                        _vm._v(
                                          "余量：" +
                                            _vm._s(
                                              _vm.detail.pickupInfo.ylQuantity
                                            )
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pad15-lr mar30-l flex radius4 pick-up-details-collect"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "发货差额：" +
                                            _vm._s(
                                              _vm.detail.pickupInfo.ceAmount
                                            ) +
                                            "元"
                                        )
                                      ]),
                                      _c("div", { staticClass: "mar20-l" }, [
                                        _vm._v(
                                          "质量扣补：" +
                                            _vm._s(
                                              _vm.detail.pickupInfo.kbAmount
                                            ) +
                                            "元"
                                        )
                                      ]),
                                      _c("div", { staticClass: "mar20-l" }, [
                                        _vm._v(
                                          "合计：" +
                                            _vm._s(
                                              _vm.detail.pickupInfo.ceHjAmount
                                            ) +
                                            "元"
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: _vm.detail.pickupInfo.vehicleList
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "orderId",
                                    label: "提货单号",
                                    width: "160",
                                    fixed: ""
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "orderDate",
                                    label: "下单日期",
                                    width: "100"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "expectedPickupDate",
                                    label: "提货日期",
                                    width: "100"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "licensePlateNum",
                                    label: "车牌号",
                                    width: "100"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "提货数量" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  scope.row.pickupQuantity ||
                                                    "-"
                                                )
                                            ),
                                            scope.row.pickupQuantity
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.pickupGoodsUnit
                                                    )
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1490624411
                                  )
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "实提数量" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                class: {
                                                  green:
                                                    scope.row
                                                      .actualSendQuantity &&
                                                    scope.row
                                                      .actualSendQuantity !=
                                                      scope.row.pickupQuantity
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      scope.row
                                                        .actualSendQuantity ||
                                                        "-"
                                                    )
                                                ),
                                                scope.row.actualSendQuantity
                                                  ? [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .pickupGoodsUnit
                                                        )
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    429508067
                                  )
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "name", label: "司机" }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "tel",
                                    label: "联系方式",
                                    width: "114"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "idCard",
                                    label: "身份证",
                                    "show-overflow-tooltip": ""
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "receiveAddr",
                                    label: "地址",
                                    "show-overflow-tooltip": ""
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "orderStatusCn",
                                    label: "状态"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "操作", width: "80" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-link",
                                              {
                                                attrs: {
                                                  href:
                                                    "/v/order/detail/" +
                                                    scope.row.orderId,
                                                  type: "primary",
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v("详情")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    458751149
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _c(
                    "div",
                    { staticClass: "bg-white f14 pad20" },
                    [
                      _c("logistics_dtl", {
                        attrs: {
                          orderDelivery: _vm.orderDelivery,
                          goodsPic: _vm.orderGoodsList[0].goodsPic
                        }
                      }),
                      _c("order_basic_info_dtl", {
                        attrs: { detail: _vm.detail }
                      }),
                      _vm.detail.relationOrderId
                        ? _c(
                            "div",
                            { staticClass: "pad20 flex mar20-b border" },
                            [
                              _vm.detail.electronicSend &&
                              _vm.detail.electronicSend[0]
                                ? _c(
                                    "div",
                                    { staticClass: "flex mar10-tb mar40-r" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "nowrap pad10-r" },
                                        [_vm._v("发货单：")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-auto flex flex-wrap"
                                        },
                                        _vm._l(
                                          _vm.detail.electronicSend,
                                          function(item) {
                                            return _c(
                                              "div",
                                              {
                                                key: item.contractSignNum,
                                                staticClass: "blue pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.contractPreviewHandle(
                                                      item.contractSignNum
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      item.contractSignNum
                                                    ) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.detail.electronicReceipt &&
                              _vm.detail.electronicReceipt[0]
                                ? _c(
                                    "div",
                                    { staticClass: "flex mar10-tb mar40-r" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "nowrap pad10-r" },
                                        [_vm._v("收货单：")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-auto flex flex-wrap"
                                        },
                                        _vm._l(
                                          _vm.detail.electronicReceipt,
                                          function(item) {
                                            return _c(
                                              "div",
                                              {
                                                key: item.contractSignNum,
                                                staticClass: "blue pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.contractPreviewHandle(
                                                      item.contractSignNum
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      item.contractSignNum
                                                    ) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "mar10-tb mar40-r" }, [
                                _vm._v("\n          预订单："),
                                _c(
                                  "a",
                                  {
                                    staticClass: "blue pointer",
                                    attrs: {
                                      href:
                                        "/v/order/detail/" +
                                        _vm.detail.relationOrderId,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.detail.relationOrderId))]
                                )
                              ]),
                              _c("div", { staticClass: "mar10-tb mar40-r" }, [
                                _vm._v(
                                  "发货差额：" +
                                    _vm._s(_vm.detail.fhCeAmount || 0)
                                )
                              ]),
                              _c("div", { staticClass: "mar10-tb mar40-r" }, [
                                _vm._v(
                                  "质量扣补：" + _vm._s(_vm.detail.kbAmount)
                                )
                              ]),
                              _c("div", { staticClass: "mar10-tb" }, [
                                _vm._v(
                                  "合计：" + _vm._s(_vm.detail.totalKbAmount)
                                )
                              ])
                            ]
                          )
                        : [
                            (_vm.detail.electronicReceipt &&
                              _vm.detail.electronicReceipt.length) ||
                            (_vm.detail.electronicSend &&
                              _vm.detail.electronicSend.length) ||
                            _vm.detail.noticeOrderContractSignNum
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pad20 flex flex-item1 mar20-b border"
                                  },
                                  [
                                    _vm.detail.electronicSend &&
                                    _vm.detail.electronicSend[0]
                                      ? _c(
                                          "div",
                                          { staticClass: "flex mar10-tb" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "nowrap pad10-r" },
                                              [_vm._v("发货单：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-auto flex flex-wrap"
                                              },
                                              _vm._l(
                                                _vm.detail.electronicSend,
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.contractSignNum,
                                                      staticClass:
                                                        "pad20-r blue pointer",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.contractPreviewHandle(
                                                            item.contractSignNum
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            item.contractSignNum
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.detail.electronicReceipt &&
                                    _vm.detail.electronicReceipt[0]
                                      ? _c(
                                          "div",
                                          { staticClass: "flex mar10-tb" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "nowrap pad10-r" },
                                              [_vm._v("收货单：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-auto flex flex-wrap"
                                              },
                                              _vm._l(
                                                _vm.detail.electronicReceipt,
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.contractSignNum,
                                                      staticClass:
                                                        "pad20-r blue pointer",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.contractPreviewHandle(
                                                            item.contractSignNum
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            item.contractSignNum
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.detail.noticeOrderContractSignNum
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex mar10-tb mar40-r"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "nowrap pad10-r" },
                                              [_vm._v("电子提货通知单：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-auto flex flex-wrap"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "blue pointer",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.contractPreviewHandle(
                                                          _vm.detail
                                                            .noticeOrderContractSignNum
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.detail
                                                            .noticeOrderContractSignNum
                                                        ) +
                                                        "\n              "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ],
                      _vm.detail.delivery == "2" &&
                      _vm.detail.orderDtlBo.orderBuyerVehicleList.length > 0
                        ? _c("div", { staticClass: "pad20 mar20-b border" }, [
                            _c(
                              "div",
                              { staticClass: "flex items-center mar15-b" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "f16 gray3 flex-auto fb" },
                                  [_vm._v("当前订单自提车辆信息")]
                                ),
                                _vm.detail.orderDtlBo.pickupCode != ""
                                  ? _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c("div", { staticClass: "mar10-r" }, [
                                          _vm._v("收货码")
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "w80 green f24" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderDtlBo.pickupCode
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm.detail.orderDtlBo.orderVehicleStatus == 0
                              ? _c(
                                  "div",
                                  [
                                    _vm.detail.orderDtlBo.orderBuyerVehicleList
                                      .length == 1 || !_vm.vehicleListCollapse
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex f14 flex-item1"
                                          },
                                          [
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("车牌号:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mar10-l" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .licensePlateNum
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("司机:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mar10-l" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("联系方式:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mar10-l mar50-r"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .tel
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("身份证号:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mar10-l" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .idCard
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _vm.detail.isSelfOperated ==
                                                    1 &&
                                                  !_vm.detail.relationOrderId
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "blue pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.orderVehicleChange(
                                                                _vm.detail
                                                                  .orderDtlBo
                                                                  .orderBuyerVehicleList[0]
                                                                  .vehicleId
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  切换车辆\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.detail.isSelfOperated ==
                                                    0 &&
                                                  !_vm.detail.relationOrderId
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "blue pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.orderVehicleDel(
                                                                _vm.detail
                                                                  .orderDtlBo
                                                                  .orderBuyerVehicleList[0]
                                                                  .vehicleId,
                                                                0
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  删除\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._l(
                                          _vm.detail.orderDtlBo
                                            .orderBuyerVehicleList,
                                          function(vehicle, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: vehicle.id,
                                                staticClass:
                                                  "flex f14 flex-item1"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("车牌号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.licensePlateNum
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("司机:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("联系方式:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l mar50-r"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.tel
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("身份证号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.idCard
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _vm.detail
                                                          .isSelfOperated ==
                                                          1 &&
                                                        !_vm.detail
                                                          .relationOrderId
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "blue pointer",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.orderVehicleChange(
                                                                      vehicle.vehicleId
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    切换车辆\n                  "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.detail
                                                          .isSelfOperated ==
                                                          0 &&
                                                        !_vm.detail
                                                          .relationOrderId
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "blue pointer",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.orderVehicleDel(
                                                                      vehicle.vehicleId,
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    删除\n                  "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                    _vm.detail.orderDtlBo.orderBuyerVehicleList
                                      .length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pad5-tb text-center blue pointer",
                                            on: {
                                              click: function($event) {
                                                _vm.vehicleListCollapse = !_vm.vehicleListCollapse
                                              }
                                            }
                                          },
                                          [
                                            _vm.vehicleListCollapse
                                              ? [_vm._v("收起")]
                                              : [_vm._v("展开")]
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    !_vm.detail.relationOrderId
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex f14 flex-item1"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex mar20-t" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pointer blue mar30-r",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.orderVehicleAddOpen()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("添加")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pointer gray6 mar30-r"
                                                  },
                                                  [_vm._v("没找到想用车辆？")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pointer blue mar10-l",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.vehicleAddOpen()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("新增")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.detail.orderDtlBo.orderVehicleStatus == 1
                              ? _c(
                                  "div",
                                  [
                                    _vm.detail.orderDtlBo.orderBuyerVehicleList
                                      .length == 1 || !_vm.vehicleListCollapse
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex f14 flex-item1"
                                          },
                                          [
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("车牌号:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mar10-l" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .licensePlateNum
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("司机:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mar10-l" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("联系方式:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mar10-l mar50-r"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .tel
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "flex mar10-b" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "gray6" },
                                                    [_vm._v("身份证号:")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mar10-l" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detail.orderDtlBo
                                                            .orderBuyerVehicleList[0]
                                                            .idCard
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._m(2)
                                          ]
                                        )
                                      : _vm._l(
                                          _vm.detail.orderDtlBo
                                            .orderBuyerVehicleList,
                                          function(vehicle) {
                                            return _c(
                                              "div",
                                              {
                                                key: vehicle.id,
                                                staticClass:
                                                  "flex f14 flex-item1"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("车牌号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.licensePlateNum
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("司机:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("联系方式:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l mar50-r"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.tel
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("身份证号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.idCard
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._m(3, true)
                                              ]
                                            )
                                          }
                                        ),
                                    _vm.detail.orderDtlBo.orderBuyerVehicleList
                                      .length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pad5-tb text-center blue pointer",
                                            on: {
                                              click: function($event) {
                                                _vm.vehicleListCollapse = !_vm.vehicleListCollapse
                                              }
                                            }
                                          },
                                          [
                                            _vm.vehicleListCollapse
                                              ? [_vm._v("收起")]
                                              : [_vm._v("展开")]
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.detail.delivery == "2" &&
                      _vm.detail.orderDtlBo.orderSellVehicleList.length > 0
                        ? _c("div", { staticClass: "pad20 mar20-b border" }, [
                            _c(
                              "div",
                              { staticClass: "flex items-center mar15-b" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "f16 gray3 flex-auto fb" },
                                  [_vm._v("关联销售订单自提车辆信息")]
                                ),
                                _vm.detail.orderDtlBo.pickupCode != ""
                                  ? _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c("div", { staticClass: "mar10-r" }, [
                                          _vm._v("收货码")
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "w80 green f24" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detail.orderDtlBo.pickupCode
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm.detail.orderDtlBo.orderSellVehicleList.length >
                            0
                              ? _c(
                                  "div",
                                  [
                                    _vm.detail.orderDtlBo.orderSellVehicleList
                                      .length == 1 || !_vm.vehicleListCollapse
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex f14 flex-item1"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-auto f14 flex-item1"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("车牌号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.detail
                                                                  .orderDtlBo
                                                                  .orderSellVehicleList[0]
                                                                  .licensePlateNum
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("司机:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.detail
                                                                  .orderDtlBo
                                                                  .orderSellVehicleList[0]
                                                                  .name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("联系方式:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l mar50-r"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.detail
                                                                  .orderDtlBo
                                                                  .orderSellVehicleList[0]
                                                                  .tel
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("身份证号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.detail
                                                                  .orderDtlBo
                                                                  .orderSellVehicleList[0]
                                                                  .idCard
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._m(4)
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._l(
                                          _vm.detail.orderDtlBo
                                            .orderSellVehicleList,
                                          function(vehicle) {
                                            return _c(
                                              "div",
                                              {
                                                key: vehicle.id,
                                                staticClass:
                                                  "flex f14 flex-item1"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("车牌号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.licensePlateNum
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("司机:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("联系方式:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l mar50-r"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.tel
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mar10-b"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "gray6"
                                                          },
                                                          [_vm._v("身份证号:")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mar10-l"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vehicle.idCard
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._m(5, true)
                                              ]
                                            )
                                          }
                                        ),
                                    _vm.detail.orderDtlBo.orderSellVehicleList
                                      .length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pad5-tb text-center blue pointer",
                                            on: {
                                              click: function($event) {
                                                _vm.vehicleListCollapse = !_vm.vehicleListCollapse
                                              }
                                            }
                                          },
                                          [
                                            _vm.vehicleListCollapse
                                              ? [_vm._v("收起")]
                                              : [_vm._v("展开")]
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.detail.delivery == "1" &&
                      _vm.detail.purchaseOrderId == "" &&
                      _vm.detail.orderDtlBo.pickupCode != ""
                        ? _c("div", { staticClass: "pad20 mar20-b border" }, [
                            _c(
                              "div",
                              { staticClass: "flex items-center mar15-b" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "f16 gray3 flex-auto fb" },
                                  [_vm._v("车辆信息")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c("div", { staticClass: "mar10-r" }, [
                                      _vm._v("收货码")
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "w80 green f24" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.detail.orderDtlBo.pickupCode
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pad20 flex flex-item1 mar20-b flex-item1 border certificate"
                        },
                        [
                          _c("div", { staticClass: "flex flex-column item" }, [
                            _vm._m(6),
                            _c("div", { staticClass: "pad10-b" }, [
                              _vm._v(
                                "选择图片后需点击【确认上传】按钮完成凭证上传"
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "flex flex-wrap upload" },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex justify-center relative pointer box"
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "uploadVoucher",
                                          attrs: {
                                            multiple: "",
                                            limit: 30,
                                            action:
                                              _vm.env.VUE_APP_fileserver +
                                              "persistentUpload",
                                            "list-type": "picture-card",
                                            "file-list":
                                              _vm.buyerVoucherPicList,
                                            "on-success":
                                              _vm.uploadVoucherSuccess,
                                            "on-remove":
                                              _vm.uploadVoucherRemove,
                                            "before-upload": _vm.uploadBefore,
                                            "on-exceed": _vm.uploadVoucherExceed
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("./images/add.png")
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-right pad15-r" },
                                    [_vm._v("上传文件")]
                                  )
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "mar10-l",
                                    on: { click: _vm.imgTransfer }
                                  },
                                  [
                                    _vm._m(7),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        class: {
                                          "pad10-t":
                                            _vm.buyerVoucherPicList &&
                                            _vm.buyerVoucherPicList.length
                                        }
                                      },
                                      [_vm._v("手机传图")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pointer white text-center mar20-t upload-btn",
                                on: { click: _vm.submitBuyerVoucher }
                              },
                              [_vm._v("确认上传")]
                            ),
                            _c("div", { staticClass: "flex-auto" })
                          ]),
                          _c("div", { staticClass: "border-l pad20-l item" }, [
                            _c("div", { staticClass: "f16 fb mar15-b" }, [
                              _vm._v("订单凭证")
                            ]),
                            _vm.detail.voucherPicMapList &&
                            _vm.detail.voucherPicMapList.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "relative certificate",
                                    staticStyle: {
                                      height: "270px",
                                      "overflow-y": "auto"
                                    }
                                  },
                                  _vm._l(_vm.detail.voucherPicMapList, function(
                                    voucherMap,
                                    voucherMapIdnex
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: voucherMapIdnex,
                                        staticClass: "relative"
                                      },
                                      [
                                        voucherMapIdnex !=
                                        _vm.detail.voucherPicMapList.length - 1
                                          ? _c("div", {
                                              staticClass: "line",
                                              staticStyle: { bottom: "-28px" }
                                            })
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "flex items-center" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex items-center mar5-r"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "radius20 z-index2 ball"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        voucherMap.voucherType ==
                                                          "SELLER"
                                                          ? "卖家"
                                                          : "买家"
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          voucherMap.boIdName
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          voucherMap.boIdPhone
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "gray9" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    voucherMap.creationDate
                                                  )
                                                )
                                              ]
                                            ),
                                            voucherMap.voucherType == "BUYER" &&
                                            (_vm.detail.orderStatus == "1" ||
                                              _vm.detail.orderStatus == "2" ||
                                              _vm.detail.orderStatus == "3")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "mar10-l red",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.delBuyerVoucherMap(
                                                          voucherMap
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  删除\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex mar10-t mar20-b mar19-l flex-wrap"
                                          },
                                          _vm._l(
                                            voucherMap.voucherPicList,
                                            function(vouche, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "wh64 mar5-b radius4 mar5-r relative overflow"
                                                },
                                                [
                                                  voucherMap.voucherType ==
                                                    "BUYER" &&
                                                  (_vm.detail.orderStatus ==
                                                    "1" ||
                                                    _vm.detail.orderStatus ==
                                                      "2" ||
                                                    _vm.detail.orderStatus ==
                                                      "3")
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex radius100 del-voucher absolute justify-center items-center pointer del",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.delBuyerVoucher(
                                                                vouche.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: require("./images/del.png")
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !_vm.isZip(vouche.url)
                                                    ? _c("el-image", {
                                                        attrs: {
                                                          src:
                                                            vouche.url +
                                                            "?imageView2/1/w/80/h/80",
                                                          "preview-src-list": voucherMap.voucherPicList.map(
                                                            function(item) {
                                                              return item.url
                                                            }
                                                          ),
                                                          "initial-index": index
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm.isZip(vouche.url)
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "line-height":
                                                              "64px",
                                                            display: "block",
                                                            "text-align":
                                                              "center"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: vouche.url
                                                              }
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                attrs: {
                                                                  src:
                                                                    "https://files.nxin.com/mobile/public/zip.png"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                            _vm.detail.takeGoodsNum != ""
                              ? _c(
                                  "div",
                                  { staticClass: "flex mar40-t items-center" },
                                  [
                                    _c("div", [_vm._v("提货单号：")]),
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.detail.takeGoodsNum))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm.cfyCard == 1
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "pad20 flex flex-item1 mar20-b border"
                            },
                            [
                              _vm._m(8),
                              _c(
                                "div",
                                { staticClass: "item border-l pad20-l" },
                                [
                                  _c("div", { staticClass: "f16 mar15-b fb" }, [
                                    _vm._v("上传照片")
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-wrap upload" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex flex-wrap upload"
                                        },
                                        _vm._l(
                                          _vm.detail.buyerCfyVoucherPicList,
                                          function(cfyVoucher) {
                                            return _c(
                                              "div",
                                              {
                                                key: cfyVoucher.id,
                                                staticClass:
                                                  "mar10-r relative box"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      cfyVoucher.url +
                                                      "?imageView2/1/w/80/h/80"
                                                  }
                                                })
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-center items-center relative pointer box"
                                        },
                                        [
                                          _c(
                                            "el-upload",
                                            {
                                              attrs: {
                                                limit:
                                                  30 -
                                                  _vm.detail
                                                    .buyerCfyVoucherPicList
                                                    .length,
                                                action:
                                                  _vm.env.VUE_APP_fileserver +
                                                  "persistentUpload",
                                                "file-list":
                                                  _vm.buyerCfyVoucherPicList,
                                                "list-type": "picture-card",
                                                "on-success":
                                                  _vm.uploadCfyVoucherSuccess,
                                                "before-upload":
                                                  _vm.uploadBefore,
                                                "on-remove":
                                                  _vm.uploadCfyVoucherRemove,
                                                "on-exceed":
                                                  _vm.uploadCfyVoucherExceed
                                              }
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("./images/add.png")
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("div", { staticClass: "flex-auto" }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pointer white text-center mar20-t upload-btn",
                                      on: { click: _vm.submitBuyerCfyVoucher }
                                    },
                                    [_vm._v("确认上传")]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _c("order_pay_info_dtl", {
                        attrs: { detail: _vm.detail }
                      })
                    ],
                    2
                  ),
              _c(
                "div",
                { staticClass: "bg-white f14 pad20" },
                [
                  _c("order_goods_info_dtl", {
                    attrs: {
                      orderGoodsList: _vm.orderGoodsList,
                      orderGoodsGiftBoList: _vm.orderGoodsGiftBoList
                    }
                  })
                ],
                1
              ),
              [
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "订单快照",
                      visible: _vm.editOrderSnapshotDialogVisible,
                      width: "800px"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.editOrderSnapshotDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c("el-alert", {
                      staticClass: "mar20-b",
                      attrs: {
                        title:
                          "交易快照包含订单创建时的商品描述和下单信息，买卖双方和平台在发生交易争议时 该页面作为判定依据。",
                        type: "error",
                        effect: "dark",
                        closable: false
                      }
                    }),
                    _c("el-divider"),
                    _c(
                      "el-row",
                      _vm._l(_vm.orderGoodsList, function(orderGoods, index) {
                        return _c(
                          "el-col",
                          {
                            key: index,
                            staticClass: "mar10-b",
                            attrs: { span: 5, offset: 1 }
                          },
                          [
                            _c(
                              "el-card",
                              { attrs: { "body-style": { padding: "0px" } } },
                              [
                                _c("img", {
                                  staticClass: "image",
                                  attrs: {
                                    src:
                                      orderGoods.goodsPic +
                                      "?imageView2/1/w/156/h/156"
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticStyle: { padding: "14px" } },
                                  [
                                    _c("span", { staticClass: "mar10-r" }, [
                                      _vm._v(
                                        "¥ " + _vm._s(orderGoods.sellFactPrice)
                                      )
                                    ]),
                                    _c("span", [
                                      _vm._v(_vm._s(orderGoods.goodsSpec))
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _c("el-divider"),
                    _c(
                      "el-form",
                      {
                        staticClass: "mar20-b",
                        attrs: {
                          "label-suffix": "：",
                          "label-position": "left",
                          size: "medium"
                        }
                      },
                      [
                        _c("el-form-item", [
                          _c("div", { staticClass: "flex" }, [
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar30-l" }, [
                                _vm._v("下单时间：")
                              ]),
                              _c("div", { staticClass: "w200" }, [
                                _vm._v(_vm._s(_vm.detail.orderTime))
                              ])
                            ]),
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar10-lr" }, [
                                _vm._v("支付类型：")
                              ]),
                              _c("div", [
                                _vm._v(_vm._s(_vm.detail.paymentTypeCn))
                              ])
                            ])
                          ])
                        ]),
                        _c("el-form-item", [
                          _c("div", { staticClass: "flex" }, [
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar30-l" }, [
                                _vm._v("订单金额：")
                              ]),
                              _c("div", { staticClass: "w200" }, [
                                _vm._v(
                                  "\n                  ¥ " +
                                    _vm._s(
                                      _vm.detail.fmoney
                                        ? parseFloat(
                                            _vm.detail.fmoney.toString()
                                          ).toFixed(2)
                                        : "0.00"
                                    ) +
                                    "\n                  （含运费\n                  " +
                                    _vm._s(
                                      _vm.detail.freightMoney
                                        ? parseFloat(
                                            _vm.detail.freightMoney.toString()
                                          ).toFixed(2)
                                        : "0.00"
                                    ) +
                                    "\n                  ）\n                "
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "mar10-lr" }, [
                                _vm._v("实付金额：")
                              ]),
                              _c("div", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.detail.pmoney
                                        ? parseFloat(
                                            _vm.detail.pmoney.toString()
                                          ).toFixed(2)
                                        : "0.00"
                                    )
                                )
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "medium" },
                            on: {
                              click: function($event) {
                                _vm.editOrderSnapshotDialogVisible = false
                              }
                            }
                          },
                          [_vm._v("关 闭")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "选择自提车辆",
                      visible: _vm.checkCartDialogVisible,
                      width: "50%"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.checkCartDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "960px" },
                        attrs: { data: _vm.orderVehicleList }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "姓名", width: "180" }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "tel", label: "手机号", width: "180" }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "licensePlateNum",
                            label: "车牌号",
                            width: "180"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "encryptionIdCard", label: "身份证号" }
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.thisVehicleChangeId != scope.row.id
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                return _vm.checkCartEdit(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("选择")]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1146802167
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "添加自提车辆",
                      visible: _vm.addCartDialogVisible,
                      width: "50%"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.addCartDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "orderVehicleTable",
                        staticStyle: { width: "960px" },
                        attrs: {
                          data: _vm.orderVehicleList,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleAddCartChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "55",
                            "reserve-selection": true,
                            selectable: _vm.selectCartDisable
                          }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "姓名", width: "180" }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "tel", label: "手机号", width: "180" }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "licensePlateNum",
                            label: "车牌号",
                            width: "180"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "encryptionIdCard", label: "身份证号" }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "mar20-t text-right" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.removeSelectCart()
                              }
                            }
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.saveSelectCart()
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "新增自提车辆",
                      visible: _vm.vehicleAddDialogVisible,
                      width: "40%"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.vehicleAddDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "vehicleRef",
                        staticClass: "demo-ruleForm",
                        attrs: {
                          model: _vm.vehicleForm,
                          rules: _vm.vehicleRules,
                          "label-width": "100px"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "车主姓名", prop: "name" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "20",
                                placeholder: "请填写车主姓名"
                              },
                              model: {
                                value: _vm.vehicleForm.name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "vehicleForm.name"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机号", prop: "tel" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "11",
                                placeholder: "请填写车主联系方式"
                              },
                              model: {
                                value: _vm.vehicleForm.tel,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "tel",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "vehicleForm.tel"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "车牌号码",
                              prop: "licensePlateNum"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "8",
                                placeholder: "请填写车主车牌号码"
                              },
                              model: {
                                value: _vm.vehicleForm.licensePlateNum,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "licensePlateNum",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "vehicleForm.licensePlateNum"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "身份证号" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "18",
                                placeholder: "请填写车主身份证，非必填"
                              },
                              model: {
                                value: _vm.vehicleForm.idCard,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "idCard",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "vehicleForm.idCard"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.vehicleFormSubmit("vehicleRef")
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      visible: _vm.dialogFormVisible,
                      title: "发票信息",
                      width: "600px"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogFormVisible = $event
                      },
                      close: _vm.invoiceOpenZZ
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "footer",
                          fn: function() {
                            return [
                              _c(
                                "span",
                                { staticClass: "dialog-footer" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { plain: "" },
                                      on: { click: _vm.cancleForm }
                                    },
                                    [_vm._v("不开发票")]
                                  ),
                                  _vm.invoiceOnLine
                                    ? [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { plain: "" },
                                            on: { click: _vm.invoiceOpenZZ }
                                          },
                                          [_vm._v("开纸质发票")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: { click: _vm.invoiceRefresh }
                                          },
                                          [_vm._v("刷新页面")]
                                        )
                                      ]
                                    : [
                                        !_vm.invoiceSaveEnabled
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    _vm.invoiceSaveDisabledTips,
                                                  placement: "top"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      disabled: !_vm.invoiceSaveEnabled
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.confirmForm(
                                                          "formRef"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" 保存 ")]
                                                )
                                              ],
                                              1
                                            )
                                          : _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  disabled: !_vm.invoiceSaveEnabled
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmForm(
                                                      "formRef"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" 保存 ")]
                                            )
                                      ]
                                ],
                                2
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      4269486388
                    )
                  },
                  [
                    _vm.invoiceOnLine
                      ? _c(
                          "div",
                          {
                            staticClass: "flex justify-center items-center h180"
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.invoiceInfo.invoiceQrCode }
                            })
                          ]
                        )
                      : _c(
                          "el-form",
                          {
                            ref: "formRef",
                            attrs: { model: _vm.form, rules: _vm.invoiceRule }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "发票种类",
                                  "label-width": "150px"
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { input: _vm.invoiceInput },
                                    model: {
                                      value: _vm.form.issueType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "issueType", $$v)
                                      },
                                      expression: "form.issueType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "ZZ", border: "" } },
                                      [_vm._v("纸质发票")]
                                    ),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "DZ", border: "" } },
                                      [_vm._v("电子发票")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "发票类型",
                                  "label-width": "150px"
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: {
                                      change: function($event) {
                                        return _vm.changeTypeCheck()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "type", $$v)
                                      },
                                      expression: "form.type"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "PTFP", border: "" } },
                                      [_vm._v("普通发票")]
                                    ),
                                    _vm.isZzInvoice == 1
                                      ? _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: "ZZSZYFP",
                                              border: ""
                                            }
                                          },
                                          [_vm._v("增值税专用发票")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm.titleShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "抬头类型",
                                      "label-width": "150px"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: {
                                          change: function($event) {
                                            return _vm.changeTypeCheck()
                                          }
                                        },
                                        model: {
                                          value: _vm.form.invoicetitleType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "invoicetitleType",
                                              $$v
                                            )
                                          },
                                          expression: "form.invoicetitleType"
                                        }
                                      },
                                      [
                                        !_vm.form.nameDisabled
                                          ? _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  label: "GR",
                                                  border: ""
                                                }
                                              },
                                              [_vm._v("个人/非企业单位")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: { label: "QY", border: "" }
                                          },
                                          [_vm._v("企业")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "name",
                                  label: "发票抬头",
                                  "label-width": "150px"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.form.nameDisabled,
                                    placeholder: "请输入发票抬头"
                                  },
                                  model: {
                                    value: _vm.form.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "name", $$v)
                                    },
                                    expression: "form.name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.viewShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      required: "",
                                      prop: "code",
                                      label: "税号",
                                      "label-width": "150px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "20",
                                        placeholder: "请输入税号"
                                      },
                                      model: {
                                        value: _vm.form.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "code", $$v)
                                        },
                                        expression: "form.code"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.viewShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "addr",
                                      label: "企业地址",
                                      "label-width": "150px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.invoiceQyAddrTip
                                      },
                                      model: {
                                        value: _vm.form.addr,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "addr", $$v)
                                        },
                                        expression: "form.addr"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.viewShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "tel",
                                      label: "企业电话",
                                      "label-width": "150px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "20",
                                        placeholder: _vm.invoiceQyTelTip
                                      },
                                      model: {
                                        value: _vm.form.tel,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "tel", $$v)
                                        },
                                        expression: "form.tel"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.viewShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "bankName",
                                      label: "开户银行",
                                      "label-width": "150px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.invoiceQyBankTip
                                      },
                                      model: {
                                        value: _vm.form.bankName,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "bankName", $$v)
                                        },
                                        expression: "form.bankName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.viewShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "bankCode",
                                      label: "银行账号",
                                      "label-width": "150px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.invoiceQyBankNoTip
                                      },
                                      model: {
                                        value: _vm.form.bankCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "bankCode", $$v)
                                        },
                                        expression: "form.bankCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showInvoiceContractAgreement
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "invoice-agreement-group",
                                    attrs: { label: "", "label-width": "150px" }
                                  },
                                  [
                                    _vm.showBasicCaAgreement
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "invoice-agreement-item"
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                on: {
                                                  change:
                                                    _vm.onBasicCaCheckedChange
                                                },
                                                model: {
                                                  value: _vm.basicCaChecked,
                                                  callback: function($$v) {
                                                    _vm.basicCaChecked = $$v
                                                  },
                                                  expression: "basicCaChecked"
                                                }
                                              },
                                              [_vm._v("我已阅读并同意")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "invoice-agreement-name pointer",
                                                on: {
                                                  click:
                                                    _vm.openBasicCaAgreement
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "《" +
                                                    _vm._s(
                                                      _vm.basicCaAgreementName
                                                    ) +
                                                    "》"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "invoice-agreement-item" },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            model: {
                                              value: _vm.checked,
                                              callback: function($$v) {
                                                _vm.checked = $$v
                                              },
                                              expression: "checked"
                                            }
                                          },
                                          [_vm._v("我已阅读并同意")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "invoice-agreement-name pointer",
                                            on: { click: _vm.previewAgreement }
                                          },
                                          [_vm._v(_vm._s(_vm.contractName))]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      "el-dialog": "",
                      width: "50%",
                      title: "上上签服务协议",
                      visible: _vm.bestsignContentVisible,
                      "append-to-body": ""
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.bestsignContentVisible = $event
                      }
                    }
                  },
                  [_c("bestsign")],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    staticClass: "basic-ca-auth-file-dialog",
                    attrs: {
                      title: "重要事项提醒",
                      visible: _vm.basicCaAuthFileDialogVisible,
                      width: "420px",
                      "append-to-body": "",
                      "close-on-click-modal": false,
                      "show-close": false,
                      center: ""
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.basicCaAuthFileDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "basic-ca-auth-file-content" }, [
                      _c("p", [
                        _vm._v("1、请打印《企业授权书》并盖章，提供PDF或图片")
                      ]),
                      _c("p", [
                        _vm._v("2、请保证授权书中"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v("被授权人与当前操作人保持一致")
                        ]),
                        _vm._v("以免认证失败")
                      ]),
                      _c(
                        "a",
                        {
                          staticClass: "basic-ca-auth-file-download",
                          attrs: {
                            href: _vm.basicCaAuthFileTemplateUrl,
                            target: "_blank"
                          }
                        },
                        [_vm._v("点击下载《企业授权书》模版")]
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "basic-ca-auth-file-footer",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "medium", type: "primary" },
                            on: { click: _vm.onBasicCaAuthFileReady }
                          },
                          [_vm._v("已准备好")]
                        ),
                        _c("div", { staticClass: "mar10-t" }, [
                          _c(
                            "a",
                            {
                              staticClass: "basic-ca-auth-file-cancel",
                              attrs: { href: "javascript:;" },
                              on: { click: _vm.onBasicCaAuthFileCancel }
                            },
                            [_vm._v("取消")]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "手机扫码上传",
                    visible: _vm.signatureDialogVisible,
                    width: "224px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.signatureDialogVisible = $event
                    }
                  }
                },
                [
                  _c("canvas", {
                    ref: "qrCodeCanvas",
                    attrs: { width: "250", height: "250" }
                  }),
                  _c("div", { staticClass: "text-center" }, [
                    _vm._v("支持微信和智农通")
                  ])
                ]
              ),
              _c("buyer_dialog", {
                ref: "order_buyer_dialog",
                on: { loadOrder: _vm.loadOrder }
              }),
              _c("contract_sign", {
                ref: "contract_sign_dialog",
                on: { buttonSubmit: _vm.buttonSubmit, loadOrder: _vm.loadOrder }
              })
            ],
            2
          )
        : _c("div", { staticStyle: { "min-height": "900px" } }),
      _c("contractPreview", {
        attrs: {
          url: _vm.contractPreviewUrl,
          visible: _vm.contractPreviewVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.contractPreviewVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center mar15-b" }, [
      _c("div", { staticClass: "f15 fb" }, [_vm._v("买家凭证")]),
      _c("div", { staticClass: "gray9 f12 mar10-l flex-auto" }, [
        _vm._v("最多上传30张")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex justify-center relative pointer box" },
      [
        _c("div", { staticClass: "el-upload el-upload--picture-card" }, [
          _c("img", { attrs: { src: require("./images/add.png") } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center mar15-b" }, [
      _c("div", { staticClass: "f15 fb" }, [_vm._v("买家凭证")]),
      _c("div", { staticClass: "gray9 f12 mar10-l flex-auto" }, [
        _vm._v("最多上传30张")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex justify-center relative pointer box" },
      [
        _c("div", { staticClass: "el-upload el-upload--picture-card" }, [
          _c("img", { attrs: { src: require("./images/add.png") } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "f16 mar15-b fb" }, [_vm._v("处方药凭证")]),
      _c("div", { staticClass: "mar10-b gray6" }, [
        _vm._v(
          "您的订单包含处方药商品根据《兽药处方药和非处方药管理办法》规定："
        )
      ]),
      _c("div", { staticClass: "gray6" }, [
        _vm._v(
          "\n            A、如果您是经营的兽药门店、宠物用品经营到位，科研单位、学校、动物园，提供营业执照或者单位证明照片即可购买"
        ),
        _c("br"),
        _vm._v(
          "\n            B、如果您是养殖户或养殖场，需提供执业首医师开具的兽药处方方可购买\n          "
        )
      ]),
      _c("div", { staticClass: "mar15-t yellow" }, [
        _vm._v("注意：不能提供身份证明或者处方信息的，卖家依照法规有权拒绝发货")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }